import script from "./SuperInvestorsInvestorsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperInvestorsInvestorsDetail.vue?vue&type=script&setup=true&lang=js"

import "./SuperInvestorsInvestorsDetail.vue?vue&type=style&index=0&id=44d6bfcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44d6bfcc"]])

export default __exports__